/**
 * A text field's "n / max characters." line, tied to the field by `id` (the field's `aria-describedby`) and announced
 * politely as it changes. `children` adds a sentence after the count.
 */

import type { ReactNode } from 'react';

export function CharCount({ id, value, max, children }: { id: string; value: string; max: number; children?: ReactNode }) {
  return (
    <span id={id} className="hint char-count" aria-live="polite">
      {value.length.toLocaleString('en-US')} / {max.toLocaleString('en-US')} characters.{children ? <> {children}</> : null}
    </span>
  );
}
